import cs from 'classnames';
import React from 'react';
import css from './index.css';
import {connect} from 'react-redux';
import mapDispatch from '~/misc/mapDispatch';
import {changeStatus, changeSelected} from '~/modules/alert/actions';
import cloneDeep from 'lodash/cloneDeep';
import {datesWithoutPast, isPastDay, formatDate, dayKey} from '~/misc/dates';
import { format, subDays } from 'date-fns';
import {push as changeURL} from 'react-router-redux';
import * as urls from '~/routing/urls';
import * as equipment from '~/misc/equipment';
import Empty from '../../ListEmpty'
import { selectedPostTruckAction, changShowCardAction } from '~/pages/PostTruck/state/action';
import { convertToPosttruck, placeBulider, convertToWeightType, POSTTRUCKSHOWTYPE ,LOADSIZEPOSTDATA} from '~/pages/PostTruck/utils';

const convertLoadAlertToPostruck = (value) => {
  const {to_location,  from_location, equipment, load_size, weight_max,length} = value;
  const weight = convertToWeightType(weight_max)[0][0];
  if(to_location && to_location.city && to_location.city.length === 1) {
    const [toLocationCity, toLocationState] =  to_location.city[0].address.split(',')
    const toLocation = placeBulider({
      ...to_location.city[0],
      city: toLocationCity,
      state: toLocationState,
    })
    return convertToPosttruck({
      equipment: equipment,
      pickup: placeBulider(from_location),
      dropoff: toLocation,
      loadSize: LOADSIZEPOSTDATA[load_size],
      weight,
      length
    })
  }
  return convertToPosttruck({
    equipment: equipment,
    dropoff: {},
    pickup: placeBulider(from_location),
    loadSize: LOADSIZEPOSTDATA[load_size],
    weight,
    length
  })
}

const RadioCheck = (props) => {
  const handleRadio = (event) => {
    props.onChange(event.target.checked, props.id);
  };
  return (
    <div className={cs(css.radioCan)}>
      <input
        type='checkbox'
        id={`radio${props.index}`}
        value=''
        name='switch'
        onChange={handleRadio}
        className={cs(css.radioCheck)}
        checked={props.isCheck}
      />
      <label htmlFor={`radio${props.index}`} className={cs(css.radio)}>
        <span className={cs(css.circle)}></span>
        <span className={cs(css.text, css.on)}></span>
        <span className={cs(css.text, css.off)}></span>
      </label>
    </div>
  );
};

const Item = (props) => {
  if(!(typeof props.data === 'object')) return null;
  const mods = {
    [css.selected]: props.data.selected,
  };

  const handleClick = () => {
    props.fn(props.data.id);
  };

  const getDate = (start, end) => {
    const s = format(start, 'YYYY/MM/D');
    const e = format(end, 'YYYY/MM/D');
    if (s === e) {
      return s;
    } else {
      return `${s}-${e}`;
    }
  };

  const getDestination = (location) => {
    if (!location || !!location.any) {
      return {address :'Anywhere', deadhead: false}
    } else {
      if ((location.city && location.state) || (location.city && location.city.length > 1) || (location.state && location.state.length > 1)) {
        return  {address :'Multiple destination', deadhead:(location.city && location.city.length&&location.city[0].deadhead) ? location.city[0].deadhead : false};
      } else if (location.city) {
        return { address : location.city[0].address, deadhead: location.city[0].deadhead};
      } else if (location.state) {
        return { address : location.state[0].address, deadhead: location.state[0].deadhead} 
      }
    }
  };

  const lengthCheck = (length, unit) => {
    if (length >= 0) {
      return ', ' + length + unit;
    } else {
      return ' '
    }
  }
  return (
    <div className={cs(css.card, {[css.offStatus]: !props.data.enabled})}>
      <div className={css.checkBoxWarp} onClick={handleClick}>
        <div className={cs(css.checkbox, mods)}/>
      </div>
      <div className={css.place}>{props.data.from_location.address}<span>({props.data.from_location.deadhead} mi)</span> <div className={css.arrow}></div> {getDestination(props.data.to_location).address} <span>{getDestination(props.data.to_location).deadhead ? `(${getDestination(props.data.to_location).deadhead} mi)` : ''}</span></div>
      <div className={cs(css.action,css.postTruck)} onClick={props.postTruck}>+ Post Truck</div>
      <div></div>
      <div className={css.splitLine}></div>
      <div></div>
      <div className={css.contentBlock}>
        <div className={css.label}>MATCH</div>
        <div 
          onClick={() => props.goToAlertLoads({id: props.data.id, e: props.data.equipment})} 
          className={ cs(css.content, css.greenWord)}
        >{props.data.count}</div>
      </div>
      <div className={css.contentBlock}>
        <div className={css.label}>PICK UP DATE</div>
        <div className={ cs(css.content)}>{getDate(props.data.pickup_start, props.data.pickup_end)}</div>
      </div>
      <div className={css.contentBlock}>
        <div className={css.label}>TRAILER TYPE</div>
        <div className={ cs(css.content, css.equipment)}>{props.data.equipment}</div>
      </div>
      <div className={css.contentBlock}>
        <div className={css.label}>OTHERS</div>
        <div 
          className={cs(css.content)}
        >{props.data.load_size + lengthCheck(props.data.weight_max, ' lbs') + lengthCheck(props.data.length, ' ft')}</div>
      </div>
      <div className={cs(css.action, css.contentBlock)}>
        <div className={css.label}>STATUS</div>
        <div className={css.content}>
          <RadioCheck
            onChange={props.radioFn}
            index={props.index}
            id={props.data.id}
            isCheck={props.data.enabled}
          />
        </div>
        
      </div>
    </div>
  );
};

class ListTable extends React.Component {
  constructor(props) {
    super(props);
    this.handleTrClick = this.handleTrClick.bind(this);
    this.handleRadioChange = this.handleRadioChange.bind(this);
    this.state = {
      isCheckArray: [],
    };
  }
  render() {
    const list = this.props.list || [];
    return (
      <div className={css.list}>
        {list.length === 0 && <Empty/>} 
        {list.length !== 0 && list.map((value, index) => {
          let obj = {
            data: value,
            index: index,
            goToAlertLoads: this.props.goToAlertLoads,
            equipment: this.props.equipment,
          };
          return (
            <Item
              {...obj}
              fn={this.handleTrClick}
              radioFn={this.handleRadioChange}
              postTruck = {()=>this.selectPostTruck(value)}
              key={index}
            />
          );
        })}
      </div>
            
    );
  }

  handleTrClick(id) {
    this.props.changeSelected(id);
  }

  handleRadioChange(event, id) {
    let idList = [id];
    this.props.changeStatus({
      idList,
      type: 'change status'
    });
  }
  selectPostTruck = (value) => {
    const { selectPostTruck, changeShowCard, goToPostTruck} = this.props;
    selectPostTruck(convertLoadAlertToPostruck(value));
    changeShowCard(POSTTRUCKSHOWTYPE.DETAIL_LOADALERT);
    goToPostTruck();
  }
}

export default connect(({alert}) => ({
  alertList: alert.alertList,
  list: alert.list,
}), mapDispatch({
  changeStatus: (props, args) => changeStatus(args),
  changeSelected: (props, data) => changeSelected(data),
  goToAlertLoads: (props, {id, e}) => changeURL(`${urls.ALERT}/${urls.ALERTURL.LoadsList}/${id}/${e}`),
  selectPostTruck: (props, data) => selectedPostTruckAction(data),
  changeShowCard: (props, type) => changShowCardAction(type),
  goToPostTruck: (props, value) => changeURL(`${urls.POSTTRUCk}`),
}))(ListTable);



// WEBPACK FOOTER //
// ./src/components/Alert/AlertList/List/ListTable/index.js